module.exports = __webpack_public_path__ + "static/img/5_male.4987de9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/character/5_male.png
// module id = 12Rh
// module chunks = 3